import VideoComp from "../videoComp/videoComp";
import ShopComp from "../shopComp/shopComp";
import ImgComp from "../imgComp/imgComp";
import Navigation from "../navigation/navigation";

//ASSETS
import emerald from "../../videos/emerald.mp4";

import img1 from "../../images/shopComp/comp4/img1.webp";
import img2 from "../../images/shopComp/comp4/img2.webp";
import img3 from "../../images/shopComp/comp4/img3.webp";
import img4 from "../../images/shopComp/comp4/img4.webp";

import Img_1 from "../../images/imgComp/imgComp4.webp";
import imgBg4 from "./images/bgs/emerald.webp";

export default function FourthComp() {
  return (
    <>
      {/* <div className="allow-scroll demo"> */}
      {/* <Navigation /> */}

      <VideoComp
        id={4}
        header={"Într-o lume a serenității caleidoscopice, "}
        idHeader={"the emerald"}
        text={
          <>
            <p>
              <b>Tăietura Emerald</b> dezvăluie o frumusețe feerică, prin
              fațetele lungi și platoul vast.
            </p>
            <p>
              {" "}
              Fațetele „step-cut” creează iluzii optice asemenea unui
              caleidoscop. Împreună, îți transpun privirea și spiritul într-o
              reverie geometrică din Sala Oglinzilor. Puternică și îndrăzneață,
              asemenea celei care o poartă.
            </p>
          </>
        }
        vidLink={emerald}
        // videoBg={imgBg4}
        videoBg={<img src={imgBg4} alt="" />}
        href={
          "https://www.teilor.com/18k-white-gold-engagement-ring-with-0-8ct-and-0-452ct-diamonds-119585.html"
        }
        buttonText={"View the ring"}
      />
      <ShopComp
        ring_1={img1}
        href_1={
          "https://www.teilor.ro/inel-de-logodna-din-aur-alb-de-18k-cu-diamant-de-0-3ct-106482.html"
        }
        ring_2={img2}
        href_2={
          "https://www.teilor.ro/lant-cu-pandant-din-aur-galben-de-18k-cu-diamant-de-0-3ct-119479.html"
        }
        ring_3={img3}
        href_3={
          "https://www.teilor.ro/cercei-din-aur-galben-de-18k-cu-diamante-de-0-8ct-106466.html"
        }
        ring_4={img4}
        href_4={
          "https://www.teilor.ro/inel-din-aur-alb-de-18k-cu-diamante-de-0-283ct-32647.html"
        }
        // mainLink={"https://www.teilor.ro/perpetual-love.html"}
      />
      <ImgComp
        img={Img_1}
        bgProp={"shape-4-bg"}
        // header={
        //   <>
        //     DRESS HOW YOU WANT TO BE ADDRESSED. <br />
        //     <span>TREAT YOURSELF.</span> RING YOURSELF.
        //   </>
        // }
        // shape={<img className="shape-4" src={Svg_4}></img>}
        rightText1={<span style={{ color: "#B4B4B4" }}>Sofisticată</span>}
        rightText2={<span style={{ color: "#797979" }}>Elegantă</span>}
        leftText1={<span style={{ color: "#484848" }}>Încrezătoare </span>}
        leftText2={<span style={{ color: "#B4B4B4" }}>Extravagantă</span>}
        mainLink={"https://www.teilor.com/perpetual-love.html"}
      />
      {/* </div> */}
    </>
  );
}
